import { KpiModel } from './kpiModel';

export class Calculator {
  kpiType = null

  constructor(pointOfSaleGuid, currentPeriod, previousPeriod, isManaged, extraResults = 0) {
    this.pointOfSaleGuid = pointOfSaleGuid;
    this.currentPeriod = currentPeriod;
    this.previousPeriod = previousPeriod;
    this.isManaged = isManaged;
    this.extraResults = extraResults;
  }

  calculateKPI() {
    throw new Error('not implemented');
  }

  executeUncubeQuery(queryClass, period) {
    // eslint-disable-next-line new-cap
    const uncubeQuery = new queryClass(this.pointOfSaleGuid, period.startDateStr,
      period.endDateStr, this.isManaged, this.extraResults);
    return uncubeQuery.execute();
  }

  getData(currentRawKpi, previousRawKpi) {
    const currentKpi = this.getValueOfKpi(currentRawKpi);
    const previousKpi = this.getValueOfKpi(previousRawKpi);
    const increment = this.getValueOfIncrement(currentKpi, previousKpi);
    return {
      key: `${this.pointOfSaleGuid}-${this.isManaged}`,
      kpi: currentKpi,
      increment,
      type: this.kpiType,
    };
  }

  getDataIfNoPreviousPeriod(currentRawKpi) {
    const currentKpi = this.getValueOfKpi(currentRawKpi);
    return {
      key: `${this.pointOfSaleGuid}-${this.isManaged}`,
      kpi: currentKpi,
      increment: null,
      type: this.kpiType,
    };
  }

  getValueOfKpi(rawKpi) {
    return Math.trunc(rawKpi * 100) / 100;
  }

  getValueOfIncrement(currentKpi, previousKpi) {
    const increment = currentKpi / previousKpi;
    return (previousKpi !== 0) ? Math.trunc((increment - 1) * 100) : 0;
  }

  getModelToInstance(props) {
    return new KpiModel(props.type, props.key, props.kpi, props.increment);
  }
}
